(function () {
  'use strict';
  if (customElements.get('ticker-bar')) return;

  customElements.define('ticker-bar', class extends HTMLElement {
    constructor() {
      super();
      this.resizeEvent = () => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => this.checkWidth(), 100);
      };
      this.onVisibility = () => this.setPlayback();
      this.onEnter = () => {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = setTimeout(() => {
          this.hovered = true;
          this.setPlayback();
        }, 500);
      };
      this.onLeave = () => {
        clearTimeout(this.hoverTimeout);
        this.hovered = false;
        this.setPlayback();
      };
      this.onFocus = () => { this.focused = true; this.setPlayback(); };
      this.onBlur = (event) => {
        this.focused = this.contains(event.relatedTarget);
        this.setPlayback();
      };
    }

    connectedCallback() {
      this.scale = this.querySelector('[data-ticker-scale]');
      this.text = this.scale?.querySelector('[data-ticker-text]:not([data-clone])');
      if (!this.scale || !this.text) return;
      this.autoplay = this.hasAttribute('data-autoplay');
      this.staticMedia = matchMedia('(max-width: 767px), (prefers-reduced-motion: reduce)');
      this.staticMedia.addEventListener('change', this.resizeEvent);
      this.scale.classList.remove('ticker--unloaded');
      this.inView = !('IntersectionObserver' in window);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.setPlayback();
        });
        this.observer.observe(this);
      }
      window.addEventListener('orientationchange', this.resizeEvent);
      document.addEventListener('theme:resize:width', this.resizeEvent);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.addEventListener('mouseenter', this.onEnter);
      this.addEventListener('mouseleave', this.onLeave);
      this.addEventListener('focusin', this.onFocus);
      this.addEventListener('focusout', this.onBlur);
      this.frame = requestAnimationFrame(() => this.checkWidth());
    }

    checkWidth() {
      if (!this.isConnected || !this.text) return;
      this.scale.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());
      this.text.classList.remove('ticker--animated');
      this.text.style.removeProperty('min-width');
      this.text.style.removeProperty('animation-play-state');
      this.toggleAttribute('data-ticker-static', this.staticMedia.matches);
      if (this.staticMedia.matches) return;
      const styles = getComputedStyle(this);
      const available = this.clientWidth - parseFloat(styles.paddingLeft || 0) - parseFloat(styles.paddingRight || 0);
      const naturalWidth = this.text.scrollWidth;
      if (available <= 0 || naturalWidth <= 0 || (!this.autoplay && naturalWidth <= available)) return;
      this.text.classList.add('ticker--animated');
      this.text.style.minWidth = `${available / 8}px`;
      const width = this.text.getBoundingClientRect().width;
      if (width <= 0) return;
      const count = Math.min(8, Math.max(1, Math.ceil(available / width)));
      for (let index = 0; index < count; index++) {
        const clone = this.text.cloneNode(true);
        clone.setAttribute('data-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex], [contenteditable], audio[controls], video[controls], iframe, object, embed').forEach((element) => element.setAttribute('tabindex', '-1'));
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        this.scale.appendChild(clone);
      }
      const speed = Number(this.getAttribute('data-marquee-speed')) || 100;
      this.scale.style.setProperty('--animation-time', `${width / 100 * 1.63 * (100 / Math.max(1, speed))}s`);
      if (this.autoplay) this.querySelectorAll('[data-aos]').forEach((element) => element.classList.add('aos-animate'));
      this.setPlayback();
    }

    setPlayback() {
      if (!this.scale) return;
      const paused = document.hidden || !this.inView || this.hovered || this.focused || this.scale.hasAttribute('data-stop');
      this.scale.querySelectorAll('[data-ticker-text]').forEach((element) => {
        if (paused) element.style.animationPlayState = 'paused';
        else element.style.removeProperty('animation-play-state');
      });
    }

    disconnectedCallback() {
      clearTimeout(this.resizeTimeout);
      clearTimeout(this.hoverTimeout);
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.staticMedia?.removeEventListener('change', this.resizeEvent);
      window.removeEventListener('orientationchange', this.resizeEvent);
      document.removeEventListener('theme:resize:width', this.resizeEvent);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.removeEventListener('mouseenter', this.onEnter);
      this.removeEventListener('mouseleave', this.onLeave);
      this.removeEventListener('focusin', this.onFocus);
      this.removeEventListener('focusout', this.onBlur);
      this.scale?.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());
      this.hovered = false;
      this.focused = false;
    }
  });
})();
